var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-toolbar',{attrs:{"crumbs":_vm.crumbs}}),_c('group-module-form',{attrs:{"value":_vm.model,"groups":_vm.groups},on:{"cancel":_vm.onCancel,"save":_vm.onSave,"delete":_vm.onDelete}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }